import { TableField, defaultCPFFormatter } from "../../table-field";

export const situacoesEmFila = [
  "Entregue",
  "Em processamento",
  "Reprocessar",
  "Em Reprocessamento",
  "Processando Extratos",
  "Aguardando Processamento",
  "Aguardando Validação",
  "Em Validação",
];

export const codSituacoesEmFila = ["E", "R", "O", "T", "F", "B", "V", "W"];

export function situacaoPcmFormatter(situacao: string): string {
  return situacoesEmFila.includes(situacao) ? "Em Fila" : situacao;
}

export const fieldsPrestacaoContasMensal: TableField[] = [
  {
    key: "IdPrestacaoConta",
    label: "ID",
    tdClass: ["align-middle", "naoQuebrar", "text-left", "text-xl-center"],
    thClass: "text-center",
    sortable: true,
  },
  {
    key: "UsuarioEntrega",
    label: "Responsável",
    tdClass: ["align-middle", "naoQuebrar", "text-left", "text-xl-center"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: true,
    formatter: defaultCPFFormatter,
  },
  {
    key: "Ano",
    label: "Ano",
    tdClass: ["align-middle", "naoQuebrar", "text-left", "text-xl-center"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: true,
  },
  {
    key: "Mes",
    label: "Mês",
    tdClass: ["align-middle", "naoQuebrar", "text-left", "text-xl-center"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: true,
  },
  {
    key: "TipoPrestacao",
    label: "Tipo de Prestação",
    tdClass: ["align-middle", "quebrarPorPalavra", "text-left", "text-xl-center"],
    thClass: ["text-center", "quebrarPorPalavra"],
    sortable: true,
  },
  {
    key: "TipoEntrega",
    label: "Tipo de Entrega",
    tdClass: ["align-middle", "naoQuebrar", "text-left", "text-xl-center"],
    thClass: ["text-center", "quebrarPorPalavra"],
    sortable: true,
  },
  {
    key: "DataEntrega",
    label: "Data de Entrega",
    tdClass: ["align-middle", "naoQuebrar", "text-left", "text-xl-center"],
    thClass: ["text-center", "quebrarPorPalavraHard"],
    sortable: true,
    formatter: (dt: Date): string => (dt ? dt.toLocaleDateString() : ""),
  },
  {
    key: "DsStatusPc",
    label: "Situação",
    tdClass: ["align-middle", "quebrarPorPalavraHard", "text-left", "text-xl-center"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: true,
    formatter: (s: string): string => situacaoPcmFormatter(s),
  },
  {
    key: "actions",
    label: "Ações",
    tdClass: ["align-middle", "col-actions", "text-left", "text-xl-center"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: false,
  },
  {
    key: "Situacao",
    label: "",
    tdClass: ["d-none"],
    thClass: ["d-none"],
    sortable: false,
  },
];
